/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { PatchApiFeedbacksIdStatusMutationResponse, PatchApiFeedbacksIdStatusPathParams, PatchApiFeedbacksIdStatus400, PatchApiFeedbacksIdStatus401, PatchApiFeedbacksIdStatus403, PatchApiFeedbacksIdStatus404, PatchApiFeedbacksIdStatus500 } from "../../types/PatchApiFeedbacksIdStatus.ts";
import { patchApiFeedbacksIdStatusMutationResponseSchema } from "../../zod/FeedbackSchemas/patchApiFeedbacksIdStatusSchema.ts";

function getPatchApiFeedbacksIdStatusUrl({ id }: { id: PatchApiFeedbacksIdStatusPathParams["Id"] }) {
  const res = { method: 'PATCH', url: `/api/feedbacks/${id}/status` as const }  
  return res
}

/**
 * @summary Изменить статус обращения
 * {@link /api/feedbacks/:Id/status}
 */
export async function patchApiFeedbacksIdStatus({ id }: { id: PatchApiFeedbacksIdStatusPathParams["Id"] }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<PatchApiFeedbacksIdStatusMutationResponse, ResponseErrorConfig<PatchApiFeedbacksIdStatus400 | PatchApiFeedbacksIdStatus401 | PatchApiFeedbacksIdStatus403 | PatchApiFeedbacksIdStatus404 | PatchApiFeedbacksIdStatus500>, unknown>({ method : "PATCH", url : getPatchApiFeedbacksIdStatusUrl({ id }).url.toString(), ... requestConfig })  
  return patchApiFeedbacksIdStatusMutationResponseSchema.parse(res.data)
}